import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { apiDelete, apiGet, apiPost, apiPut } from "./client";
import { okResponseSchema } from "./schemas";

/**
 * Gorev C (esitlik) — /api/v2/admin/imga* (yalniz super, backend/app/core/api/
 * admin_imga.py ile BIREBIR — eski legacy/admin/settings.html "İmga AI Servisi"
 * karti + js/admin-settings.js). Anahtarin KENDISI hicbir yanitta DONMEZ —
 * yalniz `api_key_set` (var/yok) + `updated_at`.
 */

export const imgaStatusSchema = z.object({
  api_key_set: z.boolean(),
  updated_at: z.string().nullable(),
  api_url: z.string(),
  tenant_id: z.string(),
  mock: z.boolean(),
});
export type ImgaStatus = z.infer<typeof imgaStatusSchema>;

export const imgaTestResultSchema = z.object({
  ok: z.boolean(),
  mock: z.boolean(),
  summary: z.string().nullable().optional(),
  error: z.string().nullable().optional(),
});
export type ImgaTestResult = z.infer<typeof imgaTestResultSchema>;

export function fetchImgaStatus(): Promise<ImgaStatus> {
  return apiGet("/api/v2/admin/imga", imgaStatusSchema);
}

export function saveImgaKeyRequest(apiKey: string) {
  return apiPut("/api/v2/admin/imga", okResponseSchema, { api_key: apiKey });
}

export function deleteImgaKeyRequest() {
  return apiDelete("/api/v2/admin/imga", okResponseSchema);
}

/** `apiKey` verilirse (henuz KAYDEDILMEMIS girdi) o deger test edilir; yoksa
 * KAYITLI anahtar test edilir — legacy `testImga()` ile ayni davranis. */
export function testImgaRequest(apiKey?: string): Promise<ImgaTestResult> {
  return apiPost("/api/v2/admin/imga/test", imgaTestResultSchema, apiKey ? { api_key: apiKey } : {});
}

// ---------------------------------------------------------------------------
// Kancalar
// ---------------------------------------------------------------------------

export const ADMIN_IMGA_QUERY_KEY = ["admin", "imga"] as const;

export function useImgaStatusQuery() {
  return useQuery({ queryKey: ADMIN_IMGA_QUERY_KEY, queryFn: fetchImgaStatus });
}

export function useSaveImgaKeyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveImgaKeyRequest,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ADMIN_IMGA_QUERY_KEY }),
  });
}

export function useDeleteImgaKeyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteImgaKeyRequest,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ADMIN_IMGA_QUERY_KEY }),
  });
}

export function useTestImgaMutation() {
  return useMutation({ mutationFn: (apiKey?: string) => testImgaRequest(apiKey) });
}
